import React from "react";
import styles from "./team.css";
import TeamConf from "./TeamConf";
import { FormattedMessage } from "react-intl";
import FontAwesome from "react-fontawesome";

class Team extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.containerIn}>
          <h2 className="heading">
            <FormattedMessage id="Team.title" defaultMessage="Meet the team" />
          </h2>
          <ul className={styles.teamList}>
            {TeamConf.team.map((team, i) => {
              return (
                <li key={i}>
                  <span
                    className={styles.partnerItemImage}
                    style={{
                      backgroundImage:
                        "url(" +
                        process.env.REACT_APP_MEDIA_CONTENT +
                        team.logo +
                        ")"
                    }}
                  />
                  <p className={styles.teamItemName}>{team.title}</p>
                  <p className={styles.teamItemPost}>{team.post}</p>
                  <a
                    className={styles.partnerItem}
                    href={team.href}
                    target="_blank"
                    key={team.href}
                  >
                    <FontAwesome
                      name="linkedin"
                      className={styles.containerSectionSocialNetworksItem}
                    />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/containers/team/Team.js